import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import i18n from './i18n/i18n'
import vuetify from './plugins/vuetify'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import '@/styles/global.scss'

Vue.config.productionTip = false
Vue.use(VueDOMPurifyHTML)

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App),
}).$mount('#app')
